'use strict';

$('.product-hotspot').hover(function () {
  setTimeout(function () {
    // Allow hotspot tooltip to fade in
    if (window.yotpo) {
      window.yotpo.refreshWidgets();
    }
  }, 500);
});